// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDatePicker } from 'ui-components';

export const StyledJalaliDatePicker = styled('div')(
  () => css`
    &.jalali-date-picker {
      cursor: pointer;
      height: 46px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      border-radius: 6px;
      padding: 0px;
      justify-content: space-between;
      position: relative;
      min-width: 50px;
      .custom-range-input {
        padding: 10px 0;
        width: 100%;
        direction: rtl;
        text-align: right;
        border: none;
        white-space: nowrap;
        &:focus,
        &:hover,
        &:active {
          outline: none;
        }
      }
      .date-time,
      .rmdp-container {
        width: 100%;
      }
    }
  `
);

export const StyledUiDatePicker = styled(UiDatePicker)(
  () => css`
    &.teal {
      .rmdp-today {
        .sd {
          color: #16898e !important;
          border: 1px solid #16898e !important;
          background-color: transparent !important;
        }
      }
      .rmdp-day span {
        font-size: 0.813rem !important;
      }

      .rmdp-week-day {
        color: #6c879b !important;
      }
      .rmdp-day.rmdp-disabled {
        .highlight-red {
          opacity: 0.5 !important;
        }
      }
    }
  `
);
